import MapComponent from "./MapComponent";
import Grid from "@mui/material/Grid";
import Paper from "@mui/material/Paper";
import React, { Component } from "react";
import CommonTile from "./CommonTile";
import Footer from "./Footer";
import Drawer from "@mui/material/Drawer";
import Button from "@mui/material/Button";
import MyServicesCommunities from './MyServicesCommunities';
import MyServicesBlog from './MyServicesBlog';
import MyServicesPresentation from './MyServicesPresentation';
import MyServicesMarketing from './MyServicesMarketing';
import MyServicesBuyingSelling from './MyServicesBuyingSelling';
import MyServicesStaging from './MyServicesStaging';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';

import _ from "lodash";

// Top Marketing
// Strong Negoitaors
// Experiaced Team
// Stagging & Photography
// Resources
// Contact Your Realtor

class ReviewsComponent extends Component {
  constructor(props) {
    super(props);
    this.mapRef = React.createRef();
    this.markers = [];

    this.state = {
      pictureHeight: "100%",
      pictureWidth: "60%",
      parentPage: "ReviewsComponent",
      selectedIndex:0,
      testimonialTiles: [
        {
          title: "  Loved Working With Donna",
          summary:
            "I loved working with Donna during my home buying process. She was fun and knowledgeable and always had a positive attitude. Her communication was quick, friendly, and I felt like a priority to her. Highly recommend!",
          name:"Julianna",
        },
        {
          title: "  Donna Is The Best",
          summary:
            "Donna is the best!! As first-time homebuyers, my husband and I were nervous to start our search. But Donna walked us through the process step by step. She created guides and checklists that made comparing homes, submitting an offer, and closing on our home easy. She was always available to answer our questions and give us advice. She truly had our best interests at heart. Donna is a wonderful agent, I can’t recommend her highly enough!",
          name:"Lisa",
        },
        {
          title: "  Donna Was So Helpful",
          summary:
            "Donna was so helpful with our search. She was understanding when we switched our search criteria many times and sent us listings that matched perfectly! She was also always available to us night, day, weekends- you name it. If you want someone reliable , knowledgeable and honest, use her for your next move!",
          name:"Erik",
        },
        {
          title: "  Hard Working",
          summary:
            "Donna always is quick to respond and will never forget to follow up. You would think that she is exclusively yours with your real estate needs, even though you are not haha Obviously, Donna loves what she does.",
          name:"Julie",
        },
        {
          title: "  Above & Beyond",
          summary:
            "After deciding to move across the country We aligned with Donna through an online virtual tour after already having a few tours with other realtors & we knew right away we were meant to be with Donna!",
          name:"Chris & Ashley",
        },
        {
          title: "  Donna Is Amazing",
          summary:
            "Donna is amazing!! She discussed ideas that could enhance my property’s value and went above and beyond with staging the property perfectly and marketing my neighborhood for potential buyers. She earned every penny of her commission which you don’t always see with realtors. And, she was present in the process all the way thru to closing. Highly recommend this gem!",
          name:"Wendy V",
        },
        {
          title: "  Incredibly Smooth",
          summary:
            "The process of selling a home with Donna was incredibly smooth. She not only is incredibly thorough explaining each part of the process, she provided guides for us to understand what came next and while we were moving out, the home looked a little sparse, she ended up bringing in staging furniture so it showed beautifully online! We sold in under one week. We couldn't ask for a better agent!",
          name:"Joe",
        },
        {
          title:"   Glad To Now Call Her A Friend", 
          summary: "Donna went above and beyond to make sure that our family was comfortable and happy during the difficult process of buying and selling! We truly thank her for her time and enthusiasm and are glad to now call her a friend",
          name: "Audrey"
        },
        {
          title:"   Donna Was Great", 
          summary:"Donna was great in helping us find a great home quickly in this crazy market! She went out of her way to do a Zoom showing at 9pm when we were away on what is now our first home. Thank you Donna!",
          name: "Ashley B"   
        },     
        {
        title:"So Very Glad",
        summary: "My husband and I are so very glad that we hired Donna. I originally had a different realtor. He although was nice the first time we met, he seemed to be quiet after.  He was not a good fit for us. Donna was the very exact opposite. She was always with a smile, was so energetic, and so very helpful. She helped stage our house, so that we would get more bids. It worked, as our house went for way more past asking price.",
        name:"Marsha & Tim"
        },
        {
          title: "    Highly Recommend",  
          summary: " She is a “SHARK” That lady is professional in her business. Available 24/7. Always ready to schedule a showing and available to do so any time it works for clients. Either 6 am or 10 pm. Highly recommend!",
          name: "Nelya S"
        },
        {
          title:"    Amazing To Work With",        
          summary:"Donna was amazing to work with. From the beginning to the end of the selling and buying process, Donna was there to advise with any and all questions to help guide us to make the best financial decisions for ourselves. Her knowledge on what to do to get the house picture perfect for the MLS listing as well as for showings was evident. Her detail in staging and wording for the listing was a work of art.",
          name: "Shana M"
        },
        {
          title:"    Great Agent",
          summary:"As a first time homebuyer, Donna made the whole process very easy and exciting. Donna is a great agent and a true expert at what she does. She goes above and beyond what is expected. I highly recommend Donna. She always made herself available whenever I had a question and made sure I was happy.  I am very happy with my experience and I will be working with Donna again in the future.",
          name: "Garth G"
        },
        {
          title:"    Amazing Work Ethic",
          summary:"Donna went above and beyond! She made the home buying process easier then the average agent. She was always available and has AMAZING work ethic. I felt loved and trusted her to find the right home for my family. We could not be happier!!!! Thanks Donna, I will gladly tell my friends and my family who to sign with!",
          name: "Bettina P"
        },
        {
          title:"Donna Was So Patient",
          summary:"As a first time home buyers, my husband and I had many questions. Donna was so patient and able to help us through each question and detail through this process. We went to see so many houses with Donna and she was very flexible with times that worked for us and helped us figure out exactly what we were looking for. I would recommend Donna to anyone looking to buy a home!",
          name:"Erin"
        },
        {
          title:"    There When I Needed Her",
          summary:"Ok so I just want to say Donna is amazing!! She was there when I needed her and she answered every question I had to ask.  She deserves so much credit and I don’t know if it can get any better then her she definitely was greatness. It feels like she was a real estate agent sent from heaven. Again really appreciate her and will be using her for my house and rentals from now on.",
          name: "Khiry S"
        },
        {
          title:"    We Were So Impressed",
          summary:"My wife and I's experience with Donna started when she dropped a personalized flier in our mailbox to list our home. We knew we were moving, but had not yet decided to go with another realtor that helped us in the past or look for a new one. We were so impressed with her initiative we called her that night (Sunday). She made time for us that night, spent almost 3 hrs with us and we set a plan to list the home.",
          name: "Jeremy & Erika"
        },
        {
          title:"    Loves What She Does",
          summary: "Donna was a Pleasure to have as our realtor. She was very personable, understanding, hard working, very timely. Donna was alwasy quick to respond and will never forget to follow up.  Donna loves what she does. She always walked that extra mile to make the whole real estate experience with her the best it can be. I cant compliment her and thank her enough! Thank you Donna!",
          name:"Julie & Don"
        },
        {
          title:"    Worked With My Schedule",
          summary:"Donna made the home buying experience as painless as possible. She was extremely responsive, very knowledgable, and worked with my schedule while still being available. I was working on a tight deadline to find a place to move and Donna made sure we met that deadline while also meeting my goals and expectations for a home. I can’t recommend her enough!",
          name:"Anthony B"
        },        
        {
          title:"    Donna is a wonderful agent",
          summary:"Donna is the best!! As first-time homebuyers, my husband and I were nervous to start our search. But Donna walked us through the process step by step. She created guides and checklists that made comparing homes, submitting an offer, and closing on our home easy. She was always available to answer our questions and give us advice. She truly had our best interests at heart. Donna is a wonderful agent, I can’t recommend her highly enough!",
          name:"Lisa",
        },



      ],     

      showPresentation: false,
      showCommunities: false,
      showAboutMe: false,
      showBlog: false,
      showMarketing: false,
      showNegotiation: false,
      showStaging: false,
      subService: "My Services",            
    }
  }


  componentDidUpdate(prevProps, prevState) {
      if (prevProps.showMyServices !== this.props.showMyServices) {
        this.setState({
          showPresentation: false,
          showCommunities: false,
          showAboutMe: false,
          showBlog: false,
          showMarketing: false,  
          showNegotiation: false,  
          showStaging: false,  
          subService:"My Services"  
        })
      }
  }


  

  
  nextSlide = () => {
    
    if(this.state.testimonialTiles && (this.state.testimonialTiles.length > 0 )){
      if(this.state.selectedIndex+1 < (this.state.testimonialTiles.length)){
        this.setState({
          selectedIndex: this.state.selectedIndex+1
        })
      }else{
        this.setState({
          selectedIndex: 0
        })
      }
    }
  }

  previousSlide = () => {
    if(this.state.testimonialTiles && this.state.testimonialTiles.length > 0){
      if(this.state.selectedIndex > 0){
        this.setState({
          selectedIndex: this.state.selectedIndex-1
        })
      }else{
        this.setState({
          selectedIndex: this.state.testimonialTiles.length-1
        })
      }
    }
  }


  getTestimonialTiles = () => {
    return (
      <React.Fragment>
        <Grid
          item
          sx={{
            
            padding: "10px",
            height: {
              sm: "100%",
            },
            border: "0px solid red",

          }}
          xl={2}
          lg={2}
          md={2}
          sm={12}
          xs={6}
        >
            <Grid
              container
              direction="row"
              justifyContent="center"
              alignItems="center"
              sx={{
                background: "rgba(255,255,255,0)",
                height:"100%",
                width:"100%",     
                border: "0px solid red",
              }}
            >
            <Button
              onClick={() => this.previousSlide()}
              variant={this.props.theme.buttonVariant}
              sx={{
                '&:hover': {
                  border:"1px solid " + this.props.theme.bannerColor,
                  background:this.props.theme.bannerColor
                },
    
                width:"25%",
                height:"25%",
                background: this.props.theme.bannerColor,
                color:this.props.theme.bannerTextColor,
                border:"1px solid " + this.props.theme.bannerTextColor,
                padding: {
                  xs: "10px",
                  sm: "10px",
                  md: "10px",
                  lg: "10px",
                  xl: "10px"
                },
                marginRight: "0px",
                borderTopLeftRadius: "50px",
                borderTopRightRadius: "50px",
                borderBottomRightRadius: "50px",
                borderBottomLeftRadius: "50px",
                textTransform: "none",
                textAlign: "center",
                fontSize:{
                  xs:"1rem",
                  sm:"1rem",
                  md:"1.75rem",
                  lg:"1.75rem",
                  xl:"1.75rem",
                }
              }}
            >
              <ArrowBackIcon sx={{fontWeight:"bold"}}/>
            </Button>
          </Grid>
        </Grid>

        {this.props.screenSize == "xs"?
          <Grid
          item
          sx={{
            
            padding: "10px",
            height: {
              sm: "100%",
            },
            
          }}
          xl={2}
          lg={2}
          md={2}
          sm={12}
          xs={6}
        >

            <Grid
              container
              direction="row"
              justifyContent="center"
              alignItems="center"
              sx={{
                
                height:"100%",
                width:"100%",     
                border: "0px solid #AAAAAA",
              }}
            >
            <Button
              onClick={() => this.nextSlide()}
              variant={this.props.theme.buttonVariant}
              sx={{
                '&:hover': {
                  border:"1px solid " + this.props.theme.bannerColor,
                  background:this.props.theme.bannerColor
                },
    
                width:"25%",
                height:"25%",
                color:this.props.theme.bannerTextColor,
                background: this.props.theme.bannerColor,
                border:"1px solid " + this.props.theme.bannerTextColor,
                padding: {
                  xs: "10px",
                  sm: "10px",
                  md: "10px",
                  lg: "10px",
                  xl: "10px"
                },
                marginRight: "0px",
                borderTopLeftRadius: "50px",
                borderTopRightRadius: "50px",
                borderBottomRightRadius: "50px",
                borderBottomLeftRadius: "50px",
                textTransform: "none",
                textAlign: "center",
                fontSize:{
                  xs:"1rem",
                  sm:"1rem",
                  md:"1.75rem",
                  lg:"1.75rem",
                  xl:"1.75rem",
                }
              }}
            >
              <ArrowForwardIcon sx={{fontWeight:"bold"}}/>
            </Button>

          </Grid>
        </Grid>


            : null
        }

        <Grid
          item
          sx={{
            
            padding: "5px 10px 5px 10px",
            height: {
              sm: "100%",
            }
            
          }}
          xl={8}
          lg={8}
          md={8}
          sm={12}
          xs={12}
        >

            <Grid
              container
              direction="row"
              justifyContent="flex-start"
              alignItems="center"
              sx={{
                fontSize:"1.2rem",
                background: "rgba(255,255,255,0)",
                height:"100%",
                width:"100%",     
                border: "0px solid #AAAAAA",
                color:this.props.theme.bannerColor,
                fontWeight:"bold"
              }}
            >
              <div>
                <div style={{fontSize:"1.5rem", fontWeight:"bold"}}>
                  {this.state.testimonialTiles[this.state.selectedIndex].title}
                </div>                
                <div style={{fontSize:"1rem", fontWeight:"normal"}}>
                  <br/>
                  {this.state.testimonialTiles[this.state.selectedIndex].summary}
                </div>                
                <div style={{fontSize:"1rem", fontWeight:"normal", float:"right"}}>
                  <br/>
                  {this.state.testimonialTiles[this.state.selectedIndex].name}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                </div>                
              </div>                
          </Grid>
          </Grid>

          {this.props.screenSize == "xs"? null
          :
          <Grid
            item
            sx={{
              
              padding: "10px 10px 0px 10px",
              height: {
                sm: "100%",
              }
              
            }}
            xl={2}
            lg={2}
            md={2}
            sm={12}
            xs={6}
          >

            <Grid
              container
              direction="row"
              justifyContent="center"
              alignItems="center"
              sx={{
                background: "rgba(255,255,255,0)",
                height:"100%",
                width:"100%",     
                border: "0px solid #AAAAAA",
              }}
            >
            <Button
              onClick={() => this.nextSlide()}
              variant={this.props.theme.buttonVariant}
              sx={{
                '&:hover': {
                  border:"1px solid " + this.props.theme.bannerColor,
                  background:this.props.theme.bannerColor
                },
    
                width:"25%",
                height:"25%",
                color:this.props.theme.bannerTextColor,
                background: this.props.theme.bannerColor,
                border:"1px solid " + this.props.theme.bannerTextColor,
                padding: {
                  xs: "10px",
                  sm: "10px",
                  md: "10px",
                  lg: "10px",
                  xl: "10px"
                },
                marginRight: "0px",
                borderTopLeftRadius: "50px",
                borderTopRightRadius: "50px",
                borderBottomRightRadius: "50px",
                borderBottomLeftRadius: "50px",
                textTransform: "none",
                textAlign: "center",
                fontSize:{
                  xs:"1rem",
                  sm:"1rem",
                  md:"1.75rem",
                  lg:"1.75rem",
                  xl:"1.75rem",
                }
              }}
            >
              <ArrowForwardIcon sx={{fontWeight:"bold"}}/>
            </Button>

          </Grid>
          </Grid>
          }
          </React.Fragment>
        )
  }

  render() {

 
    return (
      <React.Fragment>
              <Grid
                container
                direction="row"
                justifyContent="flex-start"
                alignItems="flex-start"
                sx={{
                  height: "100%",
                  
                  border: "0px solid #333333",
                }}
              >   

                {this.getTestimonialTiles()}
            </Grid>
             
        </React.Fragment>          
    );
  }
}

export default ReviewsComponent
